<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <h1 class="ob-page-title">Welcome back, {{model.profileFirstName}}</h1>

      @if (model) {
        <section class="mt-4">
          <h2 class="ob-section-title mb-4">Overview</h2>
          @if (model.poOverview) {
            <app-podashboard [weekModel]="model.poThisWeek"
            [dashboardModel]="model.poOverview"></app-podashboard>
          }
          @if (model.spOverview) {
            <app-spdashboard [weekModel]="model.spThisWeek"
            [dashboardModel]="model.spOverview"></app-spdashboard>
          }
        </section>
      }

    </div>
  </div>
</div>